// components
import UseAuth from '../../../hooks/useAuth';
import { generalBar } from '../../../features/general/routes';
import { historyBar } from '../../../features/history/routes';
import { masterBar } from '../../../features/master/routes';
import { miscBar } from '../../../features/misc/routes';
import { miscBarForMaker } from '../../../features/misc/routes';
import { USER_ROLES } from '../../../constants';


// ----------------------------------------------------------------------

const sidebarConfigAdmin = [generalBar, historyBar, masterBar, miscBar];
const sidebarConfigCustomer = [generalBar, historyBar];
const sidebarConfigLogistics = [generalBar, historyBar];
const sidebarConfigMaker = [generalBar, historyBar, miscBarForMaker];
const sidebarConfigSupplier = [generalBar, historyBar];
const sidebarConfigToyotsu = [generalBar, historyBar, masterBar, miscBar];
const sidebarConfigDefault = [generalBar, historyBar];

/**
 * ロールによってサイドバーのコンテンツを変更する
 * @returns
 */
const sidebarConfig = () => {
  const { user } = UseAuth();
  // console.log('user', user);
  if(user) {
    const role = user.role;
    const hasRolesArray: boolean = Array.isArray(role);
    if (hasRolesArray && role.includes(USER_ROLES.FLOUR_ADMIN)) {
      return sidebarConfigAdmin;
    } else if (hasRolesArray && role.includes(USER_ROLES.FLOUR_CUSTOMER)) {
      return sidebarConfigCustomer;
    } else if (hasRolesArray && role.includes(USER_ROLES.FLOUR_LOGISTICS)) {
      return sidebarConfigLogistics;
    } else if (hasRolesArray && role.includes(USER_ROLES.FLOUR_MAKER)) {
      return sidebarConfigMaker;
    } else if (hasRolesArray && role.includes(USER_ROLES.FLOUR_SUPPLIER)) {
      return sidebarConfigSupplier;
    } else if (hasRolesArray && role.includes(USER_ROLES.FLOUR_TOYOTSU)) {
      return sidebarConfigToyotsu;
    } else {
      return sidebarConfigDefault;
    }
  } else {
    return sidebarConfigDefault;
  }
};

export default sidebarConfig;
